import { LoadState } from "../../../constants/enums";

export interface IBillTransactionTypeState {
  list: IBillTransactionType[];
  listLoading: LoadState;
  data: IBillTransactionType;
  loading: LoadState;
  error: string | null;
}

export interface IBillTransactionType {
  bill_transaction_type_id: string | null;
  customer_id: string | null;
  customer_policy_id: string | null;
  invoice_id: string | null;
  transaction_type: string;
  gl_account_code: string | null;
  transaction_type_gl_account_name: string | null;
  detail: string | null;
  status: string;
}

export const initialBillTransactionTypeState: IBillTransactionTypeState = {
  list: [],
  listLoading: LoadState.NotLoaded,
  data: {
    bill_transaction_type_id: null,
    customer_id: null,
    customer_policy_id: null,
    invoice_id: null,
    transaction_type: "",
    gl_account_code: null,
    transaction_type_gl_account_name: null,
    detail: null,
    status: "ACTIVE",
  },
  loading: LoadState.NotLoaded,
  error: null,
};
